import { Home } from 'containers/index';
import React, { FC } from 'react';

const HomePage: FC = () => <Home />;

export default HomePage;
